// extracted by mini-css-extract-plugin
module.exports = {"social_sharing":"SocialSharing_social_sharing__dAV6R","text":"SocialSharing_text__15CMY","copied":"SocialSharing_copied__5oZIj"};